import dynamic from "next/dynamic";
import React from "react";
import NumberUtil from "../util/Number";
import ChartLoading from "./chart_loading";
const Chart = dynamic(() => import("react-apexcharts"), {
  ssr: false,
  loading: () => <ChartLoading />,
});
interface TextSubtitleProp {
  title: string;
  subtitle: string;
  code: string;
  stock?: number[] | undefined;
  market_cap?: number | undefined;
  key?: number;
}

const ReferenceContainer = (prop: TextSubtitleProp) => {
  const state = {
    options: {
      stroke: {
        curve: "smooth" as const,
        width: 1.2,
      },
      fill: {
        type: "gradient",
        gradient: {
          colorStops: [
            {
              offset: 0,
              color: "#1A82FF",
              opacity: 0.6,
            },
            {
              offset: 100,
              color: "#fff",
              opacity: 1,
            },
          ],
        },
      },
      grid: {
        show: false,
      },
      tooltip: {
        enabled: true,
        x: {
          show: false,
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      xaxis: {
        labels: {
          show: false,
        },
        axisBorder: { show: false },
        tooltip: {
          enabled: false,
        },
        floating: true,
      },
      yaxis: {
        labels: {
          show: false,
        },
        axisBorder: { show: false },
        tooltip: {
          enabled: false,
        },
        floating: true,
      },
      dataLabels: {
        enabled: false,
      },
    },
    series: [
      {
        name: prop.code,
        data: prop.stock ?? [],
      },
    ],
  };
  return (
    <div className="p-6 border rounded flex flex-col border-border h-full hover:shadow-lg">
      <div className="font-bold text-center text-text-primary text-base">
        {prop.title}
      </div>
      <div className="text-center text-opacity-70">{prop.code}</div>
      <div className="my-6 text-sm whitespace-pre-line text-text-secondary">
        {prop.subtitle}
      </div>
      <div className="flex-grow"></div>
      <div className="mb-4">
        <Chart
          options={state.options}
          series={state.series}
          type="area"
          className="w-full"
          height={150}
        />
        <div className="text-center text-xs text-primary">
          최근 1년 주가차트
        </div>
      </div>
      <div className="border-t flex justify-between py-2">
        <div>주가</div>
        {prop.stock ? (
          <div>
            {NumberUtil.toShortNumber(prop.stock[prop.stock.length - 1])}원
          </div>
        ) : (
          <div className="bg-gray-200 animate-pulse rounded w-20"></div>
        )}
      </div>
      <div className="border-t flex justify-between py-2">
        <div>시가총액</div>
        {prop.market_cap ? (
          <div>{NumberUtil.toShortNumber(prop.market_cap, 2)}원</div>
        ) : (
          <div className="bg-gray-200 animate-pulse rounded w-20"></div>
        )}
      </div>
    </div>
  );
};

export default ReferenceContainer;
